/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Inventory2Outlined, Layers, ReportProblemOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";


const Formulario_Variacion_Producto = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagen fondo blanco si varia por color o material</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={2} ancho={2}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={Layers} nombre={'Nombre de la variante o talla'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={Inventory2Outlined} nombre={'Cantidad Existente'}
                                  dato={'cantidad'} {...props} type={'number'}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={ReportProblemOutlined} nombre={'Cantidad Minima'}
                                  dato={'minimo'} {...props} type={'number'}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Variacion_Producto